import { defineMessages } from 'react-intl';

export default defineMessages({
  SELECTED_COUNT: {
    defaultMessage: '{count, plural, one {# sélectionné} other {# sélectionnés}}',
  },

  ACTIONS: {
    defaultMessage: 'Actions',
  },

  CLEAR_SELECTION: {
    defaultMessage: 'Effacer la sélection',
  },
});
